module.exports = {"230604001":"龙岗街道","230604002":"银浪街道","230604004":"奋斗街道","230604005":"庆新街道","230604007":"西宾街道","230604009":"乘风街道","230604101":"喇嘛甸镇","230604580":"红骥牧场","230604581":"星火牧场","230604582":"银浪牧场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/230604.json
// module id = 733
// module chunks = 0